<template>
  <div class="main-container">
    <TheSideBar>
      <router-link :to="{name: 'usersList'}">
        <i class="fas fa-list"></i>
        Uživatelé
      </router-link>
      <router-link :to="{name: 'usersNew'}">
        <i class="fas fa-plus-circle"></i>
        Nový uživatel
      </router-link>
    </TheSideBar>
    <DataReady id="content">
      <router-view :key="$route.path"></router-view>
    </DataReady>
  </div>
</template>

<script>
import TheSideBar from 'CORE/components/side-bar/the-side-bar'
import DataReady from 'CORE/components/utilities/data-ready'

export default {
    name: 'PropertyTypesView',
    components: {
        TheSideBar,
        DataReady,
    },
}
</script>
